import LocationPicker from '@components/locationPicker';
import { t } from '@i18n';
import { Box, Kbd } from '@mantine/core';
import { useRef } from 'react';

export default function Header() {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={ref}
      css={{
        width: '100%',
        height: '100%',
        padding: '0 var(--mantine-spacing-md)',
        display: 'grid',
        gridTemplateColumns: '1fr',
        alignItems: 'center',
        gap: 'var(--mantine-spacing-xl)',
      }}
    >
      <LocationPicker
        showMaintenance
        rightSection={
          <Box
            visibleFrom="sm"
            css={{
              padding: '0 5px',
              display: 'flex',
              alignItems: 'center',
              opacity: 0.8,
            }}
          >
            <Kbd size="xs">{t('common.ctrl')}</Kbd> + <Kbd size="xs">K</Kbd>
          </Box>
        }
        css={{
          justifySelf: 'center',
          width: '100%',
          maxWidth: 800,
        }}
      />
    </div>
  );
}
